import CandidateEventRoutes from './CandidateEventRoutes';

export const AppRoute = () => {
  return <CandidateEventRoutes />;
};
